<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Circus and Physical Theatre
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Circus and Physical Theatre experienced the highest growth in revenue and the third highest growth in attendance amongst all categories, experiencing a growth of 102.7% in revenue (from $23.4m in 2018 to $47.4m in 2019) and 41.9% growth in attendance (from 0.5m in 2018 to 0.6m in 2019). The growth was primarily attributed to the Cirque du Soleil tours in 2019. </p>
          <p>The average ticket price increased by 31.4% (from $60.96 in 2018 to $80.08), which further contributed to the growth in revenue.</p>
          <p>Bans on mass gatherings, border closures and density limits introduced as part of COVID-19 restrictions resulted in a significant decline in revenue (by 52.2% to $22.7m from 2019) and attendance (by 57.0% to 0.3m) in 2020. The decline in revenue was partially offset by an 11.7% increase in the average ticket price (to $89.48).</p>
          <p>This category can be variable depending on the presence or absence of major tours by international companies in any given year, particularly Cirque du Soleil.</p>
        </div>
        <div class="sixcol last">
          <p>Major events in this category in 2019 included performances by <em>Blanc de Blanc Encore</em>, <em>Cirque Stratosphere</em>, <em>The Illusionists</em> and <em>Kurios</em> by Cirque du Soleil. Major events in this category in 2020 included <em>Cirque Stratosphere</em> and <em>Kurios</em> by Cirque du Soleil.</p>
          <p>In 2019, SA witnessed a y-o-y increase in revenue by 463.8% and growth in attendance by 887.0%. The major event in this category in SA was Circus Rio. NSW witnessed a y-o-y increase in revenue by 222.9% and a growth in attendance by 118.3%. The major events in this category in NSW were <em>Blanc de Blanc Encore</em>, <em>Cirque Stratosphere</em> and <em>Kurios</em> by Cirque du Soleil.</p>
          <p>In 2020, all states showed a y-o-y decline in revenue and attendance except QLD. QLD witnessed a y-o-y increase in revenue by 216.7% and a growth in attendance by 107.2%. The major event in this category in QLD was <em>Kurios</em> by Cirque du Soleil. The remainder of Cirque du Soleil’s Australian tour was cancelled following the introduction of COVID-19 restrictions in March 2020.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Leviathan</em>, Circa, Photo Credit: Johannes Reinhart</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [8.602, 9.9, 55.866, 54.043, 142.033, 46.095, 99.559, 73.439, 116.543, 23.41, 47.447, 22.693],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.198, 0.266, 0.729, 0.556, 1.286, 0.565, 0.975, 0.839, 1.165, 0.45, 0.639, 0.275],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 71.6],
            ["VIC", 9.3],
            ["QLD", 12.2],
            ["WA", 1.2],
            ["SA", 2.8],
            ["ACT", 2.5],
            ["TAS", 0.2],
            ["NT", 0.2]
          ],
          attendance: [
            ["NSW", 58.7],
            ["VIC", 16.3],
            ["QLD", 13.7],
            ["WA", 2.5],
            ["SA", 4.4],
            ["ACT", 2.7],
            ["TAS", 0.6],
            ["NT", 1.1]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 3.9],
            ["VIC", 11.7],
            ["QLD", 80.6],
            ["WA", 1.7],
            ["SA", 0.0],
            ["ACT", 2.0],
            ["TAS", 0.0],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 7.0],
            ["VIC", 16.0],
            ["QLD", 65.8],
            ["WA", 5.7],
            ["SA", 0.0],
            ["ACT", 5.5],
            ["TAS", 0.0],
            ["NT", 0.0]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("../../../assets/img/2019/Leviathan,-Circa,-Johannes-Reinhart_SFW2.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
